export default {
  namespaced: true,
  state: {
    obj: {
      modal: false,
      token: '',
    },
  },
  getters: {
    obj: state => state.obj,
    modal: state => state.obj.modal,
    token: state => state.obj.token,
  },
  mutations: {
    objMutate(state, data) {
      state.obj = data;
    },
  },
  actions: {
    async setObj(context, data) {
      context.commit('objMutate', data);
    },
  },
};
